import { Repository } from './repository';

import { Service } from '../entity';
import { CentralApis } from '../interfaces/internal';
import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { DataService } from '../http/dataService';
import { IUser, User } from '../models';

@Service({
  api: 'user',
  model: User,
})
@Injectable({ providedIn: 'root' })
export class UserService extends Repository<User> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).iam,
    });
  }

  createFromDTO(item: IUser): User {
    return new User(item);
  }
}
